import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll the window back to the top whenever the pathname changes.
 * If the URL includes a `#hash`, scroll the matching element into view
 * (accounting for the sticky navbar) instead of jumping to the top —
 * so `/#craft` still lands on the Craft section.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer to next paint so the target element exists in the DOM.
      const id = hash.replace('#', '');
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          // Sticky navbar is 96px (mobile) / 112px (sm+). Offset the target
          // so the section heading sits below the nav, not under it.
          const navH = window.matchMedia('(min-width: 640px)').matches ? 112 : 96;
          const y = el.getBoundingClientRect().top + window.scrollY - navH;
          window.scrollTo(0, Math.max(0, y));
          return;
        }
        window.scrollTo(0, 0);
      });
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
